<template>
  <v-container fluid>
        <v-card outlined flat class="pa-3">
            <v-toolbar flat>
              <v-toolbar-title class="text-uppercase body-1 font-weight-medium">Run Times</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>

                <!-- change date range  ~*~*~*~*~*~*~*~*~*~*~*~*~*~* --> 
                <v-col cols="5" sm="5" md="5">
                      Date Range:
                      <date-picker
                        v-model="rundate"
                        :shortcuts="shortcuts"
                        :not-after="rundateUpper"
                        clearable
                        range
                        confirm
                        width="330"
                        lang="en"
                        type="date"
                        format="YYYY-MM-DD"
                      >
                      </date-picker>
                      <v-btn @click="fetch()" class="mx-2" fab dark small color="orange darken-3">
                          <v-icon dark>sync</v-icon>
                      </v-btn>
                </v-col>

                <div class="flex-grow-1"></div>

                <!-- search ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                <v-col cols="3" sm="3" md="3">
                  <v-text-field
                      v-model="search"
                      append-icon="search"
                      label="Search"
                      single-line
                      hide-details
                      ></v-text-field>
                </v-col>
            </v-toolbar>
        
            <!-- results table ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
            <v-data-table
              :headers="headers"
              :items="meters"
              :search="search"
              :items-per-page="5"
              :sort-by="['description', 'hours']"
              :sort-desc="[false, true]"    
              v-model="meters"
              multi-sort    
              item-key="uuid"
            >
            <!-- header ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->

            <!-- no-data ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
            <template slot="no-data" class="text-left">
                <span class="subheading text-left">
                    <v-icon color="orange">warning</v-icon>
                    No generator meters found, select another date range.
                </span>
            </template>

            <!-- content  ~*~*~*~*~*~*~*~* -->            
            <template v-slot:item.hours="{ item }">
                {{ item.hours | trunc }}
            </template>
            <template v-slot:item.kWh="{ item }">
                {{ item.kWh | trunc }}
            </template>

            <!-- content summary  ~*~*~*~*~*~*~*~* -->            
            <template v-slot:body.append>
                <tr class="grey lighten-3">
                    <td class="font-weight-bold subtitle-1 text-uppercase compress pt-3 pb-3">Totals:</td>
                    <td class="text-right font-weight-bold subtitle-1 text-uppercase compress">{{ totals[0] | trunc }}</td>
                    <td class="text-right font-weight-bold subtitle-1 text-uppercase compress">{{ totals[1] | trunc }}</td>
                </tr>
            </template>

            </v-data-table>
        </v-card>
  </v-container>
</template>
<script>
import moment from 'moment'
import FacilityService from '@/services/FacilityService'
import { mapGetters } from 'vuex'
export default {
  name: 'Generator',
  filters: {
    trunc(value) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 0
      })
      return formatter.format(parseInt(value))
    }
  },
  data() {
    return {
      search: '',
      loaded: false,
      rundate: [],
      rundateUpper: '',
      shortcuts: [
        {
          text: 'Yesterday',
          onClick: () => {
            this.rundate = [
              moment()
                .subtract(1, 'days')
                .toDate(),
              moment()
                .subtract(1, 'days')
                .toDate()
            ]
          }
        },
        {
          text: 'This Month',
          onClick: () => {
            this.rundate = [
              moment()
                .startOf('month')
                .toDate(),
              moment()
                .endOf('month')
                .toDate()
            ]
          }
        },
        {
          text: 'Last Month',
          onClick: () => {
            this.rundate = [
              moment()
                .subtract(1, 'months')
                .startOf('month')
                .toDate(),
              moment()
                .subtract(1, 'months')
                .endOf('month')
                .toDate()
            ]
          }
        },
        {
          text: 'Last 6 Months',
          onClick: () => {
            this.rundate = [
              moment()
                .subtract(6, 'months')
                .startOf('month')
                .toDate(),
              moment()
                .subtract(1, 'months')
                .endOf('month')
                .toDate()
            ]
          }
        }
      ],
      headers: [
        {
          text: 'DESCRIPTION',
          align: 'left',
          sortable: true,
          value: 'description'
        },
        {
          text: 'TOTAL HOURS',
          align: 'right',
          sortable: true,
          value: 'hours'
        },
        {
          text: 'TOTAL kWh',
          align: 'right',
          sortable: true,
          value: 'kWh'
        }
      ],
      totals: [],
      meters: []
    }
  },
  computed: {
    ...mapGetters(['getFacilityId', 'getFacilityTimezone'])
  },
  created() {
    // initialize
    this.rundate = [
      moment()
        .startOf('year')
        .toDate(),
      moment()
        .subtract(1, 'day')
        .toDate()
    ]
    this.rundateUpper = moment().subtract(1, 'days')
    this.fetch()
  },
  methods: {
    fetch() {
      let s = this.$_datetimeMethod_formatDate(this.rundate[0])
      let e = this.$_datetimeMethod_formatDate(this.rundate[1])

      this.loaded = false
      FacilityService.getGeneratorsSummary(this.getFacilityId, s, e)
        .then(response => {
          if (response.data) {
            this.meters = response.data
            this.genTotals()
          }
        })
        // .catch(error => {})
    },
    genTotals() {
      this.totals[0] = 0.0
      this.totals[1] = 0.0
      for (var m = 0; m < this.meters.length; m++) {
        this.totals[0] += this.meters[m].hours
        this.totals[1] += this.meters[m].kWh
      }
    }
  }
}
</script>
